import React from 'react';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";

class App extends React.Component {

  toggle = () => {};

  render() {

    let rows = this.props.rows;
    let cols = this.props.columns;

    return(
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Feedback questions Ratings of
            Participants</MDBModalHeader>
          <MDBModalBody>
            <Col lg={"12"}>
              <Row className={"search-event-row"}>
                <Col lg={"12"} md={"12"}>
                  <MDBDataTable
                  striped
                  searching={true}
                  displayEntries={true}
                  bordered
                  responsive
                  responsiveSm
                  responsiveMd
                  responsiveLg
                  responsiveXl
                  hover
                  // className={"table thead th"}
                  data={{rows: rows, columns: cols}}
                  />
                </Col>
              </Row>
            </Col>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }

}

export default App;
